




import Vue from 'vue'
import MyPatientsDataTable from '@/components/patients/MyPatientsDataTable.vue'
import MyPatientsFilterFunctions from '@/components/patients/MyPatientsFilterFunctions.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/patient/keys'
import { getPatientName } from '@/utils/patients'
import { FlatPatient } from '@/store/modules/patient/getters'
import { PATIENT_NOUN } from '@/constants/app-variables'
import PatientMap from '@/components/map/PatientMap.vue'

const filterOptions = [
  { label: 'IN PROGRESS', value: 'active' },
  { label: 'COMPLETED', value: 'completed' },
  { label: 'ALL', value: '' },
]

type ComponentData = {
  initialLoading: boolean
  searchText: string
  filter: string
  filterOptions: Array<{ label: string; value: string }>
  selectedFilter: { label: string; value: string }
  patientNoun: string
}

export default Vue.extend({
  name: 'MapIndex',
  components: {
    PatientMap,
  },
  data(): ComponentData {
    return {
      initialLoading: true,
      searchText: '',
      filter: 'current',
      filterOptions,
      selectedFilter: filterOptions[0],
      patientNoun: PATIENT_NOUN,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, [GetterNames.patients]),
    filteredPatients(): FlatPatient[] {
      const lowerCasedSearchText = this.searchText.toLowerCase()
      return this[GetterNames.patients]
        .filter(patient => patient.status.includes(this.selectedFilter.value))
        .filter(patient => {
          const patientText = `${patient.phoneNumber} ${getPatientName(patient)}`.toLowerCase()
          return patientText.includes(lowerCasedSearchText)
        })
    },
  },
  async mounted(): Promise<void> {
    await this[ActionNames.getPatients]()
    this.initialLoading = false
  },
  methods: {
    ...mapActions(ModuleNames.patient, [ActionNames.getPatients]),
  },
})
